import { Grid, Button, IconButton, Checkbox, Paper, Table, TableBody, TableCell, TableHead, TableRow, Dialog, DialogContent, DialogTitle, DialogActions, CircularProgress, Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { useSnackbar } from 'notistack';
import { globalDeleteService, globalExportService, globalGetService } from '../../../globalServices'
import { DeletePopUp, EmptyCollection, FilterComponent, PageLoader, Pagination, RevisionHistory, SortableHeaderCell, STableLoader } from '../../shared_elements';
import EditIcon from '@material-ui/icons/Edit';
import { checkApiStatus, checkPermission } from '../../utils_v2';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from "@material-ui/icons/Delete";
import { contactFilterOps } from '.';
import ContactCRU from './ContactCRU';
import { DropzoneArea } from 'material-ui-dropzone';
import ConfigData from '../master/components/ConfigData';
import { fieldDateFormat } from '../../../constants';
import { downloadFileType } from '../../../utils';
import moment from 'moment';
import { SaveAlt } from '@material-ui/icons';
import { usePageTitleOffset } from '../../elements/CollapsibleSideNav';
const List = ({ item, onEdit, onDelete, onSelectRow, deleteContacts, currentFormDetail }) => {
    return (
        <TableRow hover tabIndex={-1}>
            <TableCell className="actions-cell" align='left' style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1 }}>
                <div style={{ width: '100px', display: 'flex', alignItems: 'center' }}>
                    <span style={{ cursor: 'pointer', display: 'flex', padding: '3px' }} onClick={(e) => e.stopPropagation()}>
                        <RevisionHistory isExp={false} buttonType={true} url={`audit/console/amairlinescontact/`} queryParams={{ action: '0,1,2', object_id: item?.id }} />
                    </span>
                    {checkPermission('config_data', 'contact_list', 'U') ?
                        <Tooltip title="Edit">
                            <IconButton size="small" color="primary" onClick={onEdit} >
                                <EditIcon color="primary" fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        : null}
                    {checkPermission('config_data', 'contact_list', 'D') ?
                        <Tooltip title="Delete">
                            <IconButton size="small" color="primary" onClick={onDelete} >
                                <DeleteIcon color='secondary' fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        : null}
                </div>
            </TableCell>
            {/* <TableCell><Checkbox checked={deleteContacts.contacts.includes(item.id)} onChange={(e) => onSelectRow(e.target.checked)} size='small' color='primary' /></TableCell>  */}
            <TableCell>{item.full_name ? item.full_name : '--'}</TableCell>
            <TableCell>{item.email ? item.email : '--'}</TableCell>
            <TableCell>{item.lessee?.name ? item.lessee?.name : '--'}</TableCell>
            <TableCell>{item.title ? item.title : '--'}</TableCell>
            <TableCell><div style={{ minWidth: '150px' }}>{item.phone_number ? item.phone_number : '--'}</div></TableCell>
            <TableCell><div style={{ minWidth: '120px' }}>{item.fax ? item.fax : '--'}</div></TableCell>
        </TableRow>
    )
}
const ImportContacts = ({ importModal, setImportModal, onImport, isLoading }) => {
    return (
        <Dialog
            open={importModal.modal}
            className='console-management-modal '
            maxWidth="lg"
        >
            <DialogTitle id="scroll-dialog-title">
                Import Contact List
            </DialogTitle>
            <DialogContent dividers={true}>
                <div style={{ width: '270px', height: '270px' }}>
                    <DropzoneArea
                        filesLimit={1}
                        maxFileSize={104857600}
                        acceptedFiles={['.xls', '.xlsx']}
                        showPreviewsInDropzone={false}
                        useChipsForPreview={true}
                        showPreviews={true}
                        dropzoneText={<p>Drag & Drop file Or Click Here </p>}
                        dropzoneClass="drag-drop-cnt"
                        maxWidth="sm"
                        showAlerts={['info', 'error']}
                        alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                        clearOnUnmount={true}
                        onChange={(files) => setImportModal({ ...importModal, data: files })}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button color="primary" size='small' onClick={() => { setImportModal({ modal: false }) }}>Cancel</Button>
                <Button disabled={importModal?.data?.length ? false : true} size='small' color="primary" variant="contained" onClick={onImport}>
                    {isLoading ? <CircularProgress color="#ffffff" size={24} /> : 'Save'}
                </Button>
            </DialogActions>

        </Dialog>
    )
}
export default function ContactList({ params }) {
    const navTitleOffset = usePageTitleOffset('configDataNavCollapsed');
    const [isLoading, setLoading] = useState(false)
    const [deleteContacts, setDeleteContacts] = useState({ modal: false, contacts: [] });
    const [addEditContact, setAddEditContact] = useState({ modal: false, mode: '', contacts: null });
    const [importModal, setImportModal] = useState({ modal: false });
    const [contacts, setContacts] = useState({ list: [], pagination: {} });
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [lessees, setLessee] = useState("");
    const [filter, setFilter] = useState({});
    const [designationOptions, setDesignationOptions] = useState([]);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    useEffect(() => {
        getContacts({per_page:50}, 'skeletonLoader')
        globalGetService('console/lessees/', {})
            .then(response => {
                if (checkApiStatus(response)) {
                    setLessee(response.data.data.lessees)
                }
            })
    }, [])
    const getContacts = (query, loaderType) => {
        if (loaderType === 'skeletonLoader') { setSkeletonLoader(true) } else { setLoading(true) }
        // keep the active sort on every refetch (pagination, filter, edit, delete)
        globalGetService(`console/airline-contact/`, { ...(sortInfo.sort ? sortInfo : {}), ...query })
            .then(response => {
                if (loaderType === 'skeletonLoader') { setSkeletonLoader(false) } else { setLoading(false) }
                if (checkApiStatus(response)) {
                    delete query.sort;
                    delete query.sort_by;
                    delete query.page;
                    delete query.per_page;
                    setContacts(response.data.data);
                    if (response.data.data?.dropdown?.values?.length) {
                        setDesignationOptions(prev => {
                            const newOptions = response.data?.data?.dropdown.values.map(v => ({ name: v }));
                            const mergedOption = [...new Map([...prev, ...newOptions].map(option => [option.name, option])).values()];
                            return mergedOption;
                        });
                    }
                    setFilter(prevFilter => {
                        const updatedFilter = { ...prevFilter };
                        if (prevFilter.title && !response.data?.data?.dropdown?.values?.includes(prevFilter.title)) {
                            delete updatedFilter.title;
                        }
                        return updatedFilter;
                    });
                    setFilter(query)
                }
            })
    }
    const toggleBulkOps = (flag) => {
        if (flag) {
            setDeleteContacts({ modal: false, contacts: contacts.list.map(item => item.id) })
        } else {
            setDeleteContacts({ modal: false, contacts: [] })
        }
    }
    const onSelectRow = (flag, id) => {
        if (flag) {
            setDeleteContacts({ ...deleteContacts, contacts: [...deleteContacts.contacts, id] })
        } else {
            setDeleteContacts({ ...deleteContacts, contacts: deleteContacts.contacts.filter(item => item !== id) })
        }
    }
    const onDeleteContact = () => {
        setLoading(true);
        globalDeleteService(`console/airline-contact/`, { ids: deleteContacts.contacts })
            .then(response => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    setDeleteContacts({ modal: false, contacts: [] })
                    getContacts({ page: 1, per_page: contacts.pagination.per_page, ...filter }, 'pageLoader');
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                }
            })
    }
    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getContacts({ ...filter, ...sortQuery, page: 1, per_page: contacts?.pagination?.per_page || 50 }, 'pageLoader');
    }
    const onImport = () => {
        console.log('Import Successful');
    }
    const onExportContact = (query) => {
        setLoading(true);
        globalExportService(`console/airline-contact/export/`,{...filter })
            .then(response => {
                downloadFileType(response, `Contact_List ${moment().format(fieldDateFormat)}`, 'xlsx')
                setLoading(false)
            });
    }
    // const getDesignationOptions = (contacts?.dropdown?.values?.map(contact => ({ name: contact })))
    let filterOps = {
        ...contactFilterOps,
        lessee_id: {
            ...contactFilterOps.lessee_id,
            options: lessees
        },
        title: {
            ...contactFilterOps.title,
             options: designationOptions || []
        }
    }
    return (
        <section className='config-container' style={{ margin: '24px 0 0 75px' }}>
            <Paper className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 89}px` }}>
                <ConfigData />
                <div className="tech-specs-content">
                    {skeletonLoader ? <STableLoader count={3} size={9} /> :
                    <div>
                        <Paper className='console-paper' style={{ padding: '5px 10px', marginBottom: "2px" }}>
                            <Grid container spacing={1}>
                                <Grid item md={8}>
                                    <FilterComponent
                                        filter={filter}
                                        filterMenu={filterOps}
                                        getResponseBack={(applyFilter) => getContacts({ ...applyFilter }, 'pageLoader')}
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                        {checkPermission('config_data', 'contact_list', 'R') ?
                                            <li className='list-inline-item'>
                                                <Button  disabled={!contacts?.list?.length} onClick={() => onExportContact({filter})} color='primary' size='small' variant='outlined' startIcon={<SaveAlt style={{ fontSize: '1.2rem' }} />}> Export </Button>
                                            </li> : null}  
                                        {checkPermission('config_data', 'contact_list', 'C') ?
                                            <li className='list-inline-item'>
                                                <Button onClick={() => setAddEditContact({ modal: true, mode: 'Add', data: {} })} color='primary' size='small' variant='contained'> <AddIcon style={{ fontSize: '1.15rem' }} /> Add new contact</Button>
                                            </li>
                                            : null}
                                        <li className='list-inline-item' style={{ cursor: 'pointer' }}>
                                            <RevisionHistory isExp={false} buttonType={true} url={`audit/console/amairlinescontact/`} queryParams={{ action: '0,1,2' }} />
                                        </li>
                                    </ul>
                                </Grid>
                            </Grid>
                        </Paper>
                        <Paper square >
                          <div style={{ height: `${(window.innerHeight - (contacts?.list?.length ? 200 : 150)) - navTitleOffset}px`, overflow: 'auto' }}>
                            <Table className='mui-table-format' stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, width: '70px' }}>Action(s)</TableCell>
                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="full_name">Name</SortableHeaderCell>
                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="email">Email</SortableHeaderCell>
                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="lessee">Lessee</SortableHeaderCell>
                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="title">Designation</SortableHeaderCell>
                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="phone_number">Phone Number</SortableHeaderCell>
                                        <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="fax">Fax</SortableHeaderCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {contacts?.list?.map((item, index) =>
                                        <List
                                            key={index}
                                            item={item}
                                            deleteContacts={deleteContacts}
                                            onEdit={() => setAddEditContact({ modal: true, mode: 'Edit', contact: item })}
                                            onDelete={() => setDeleteContacts({ modal: true, contacts: [item.id] })}
                                            onSelectRow={(flag) => onSelectRow(flag, item.id)}
                                        />
                                    )
                                    }
                                </TableBody>
                            </Table>
                                 {!contacts?.list?.length && !isLoading && !skeletonLoader ? <div style={{ textAlign: 'center' }}><EmptyCollection title={'No records found'} /></div> : null}
                             </div>
                        </Paper>
                        <Paper square>
                            <Pagination
                                pagination={contacts.pagination}
                                onChangePage={(event, newPage) => getContacts({ ...filter, page: newPage + 1, per_page: contacts.pagination.per_page }, 'pageLoader')}
                                onChangeRowsPerPage={(event) => getContacts({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                            />
                        </Paper>
                    </div>}
                </div>
            </Paper>
            {isLoading ? <PageLoader /> : null}
            {deleteContacts.modal ?
                <DeletePopUp
                    modal={deleteContacts.modal}
                    toggleModalFn={() => setDeleteContacts({ modal: false, contacts: [] })}
                    title="Delete Contact"
                    content={<h4>Are you sure you want to delete?</h4>}
                    deleteRecordFn={() => onDeleteContact()}
                /> : null
            }
            {addEditContact.modal ?
                <ContactCRU
                    addEditContact={addEditContact}
                    toggleModalFn={() => setAddEditContact({ modal: false, mode: '', contact: null })}
                    getResponseBack={() => getContacts({ page: 1, per_page: contacts.pagination.per_page, ...filter }, 'pageLoader')}
                /> : null
            }
            {
                importModal?.modal ?
                    <ImportContacts
                        setImportModal={setImportModal}
                        importModal={importModal}
                        onImport={onImport}
                        isLoading={isLoading}
                    />
                    : null
            }
        </section>
    )
}
